import React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'

type Props = {
  href: string
  className?: string
}

export const DatasourceLink: React.VFC<Props> = (props) => {
  return (
    <a
      href={props.href}
      className={props.className}
      target="_blank"
      rel="noopener"
      css={css`
        color: ${colors.textLight};
      `}
    >
      情報ソースについて
    </a>
  )
}
